// src/app/core/interceptors/loading.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

/**
 * Interceptor para mostrar/ocultar el loading automáticamente
 * Se puede deshabilitar por petición usando headers
 */
// URLs de background que no deben mostrar loading bar
const SILENT_URLS = ['/notificaciones/contador', '/notificaciones/no-leidas', '/public/branding', '/logo'];

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Skip loading para: header explícito o requests de background
  const skipLoading = req.headers.has('X-Skip-Loading')
    || SILENT_URLS.some(url => req.url.includes(url));

  if (skipLoading) {
    const newReq = req.headers.has('X-Skip-Loading')
      ? req.clone({ headers: req.headers.delete('X-Skip-Loading') })
      : req;
    return next(newReq);
  }

  loadingService.show();

  return next(req).pipe(
    finalize(() => {
      loadingService.hide();
    })
  );
};